import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { API_PREFIX as API, API_ROUTES } from '../../../constants/api_routes';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getExpense, getExpenses, postExpense, putExpense } from '../../../store/actions/expense/expense_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import Autocomplete from '../../ui_components/autocomplete_controlled';
import DatePicker from '../../ui_components/datepicker_controller';
import TextInput from '../../ui_components/text_input';
import { useSnackbar } from 'notistack';
import { EXPENSE_TAB } from '../../../constants/constants';
import { isValid } from 'date-fns';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Expense = ({ expenses }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [expenseType, setExpenseType] = useState(null);
    const [date, setDate] = useState(null);

    useEffect(() => {
        uuid && (async () => {
            const expense = await getExpense(uuid);
            if (expense?.expenseType) {
                setExpenseType(expense.expenseType);
            }
            if (expense?.date) {
                setDate(expense.date);
            }
            for (const key in expense) {
                setValue(key, expense[key]);
            }
        })();
        !expenses.collection.length && dispatch(getExpenses());
    }, [uuid]);

    const handleExpenseTypeObject = (object) => {
        const expense = object ? (object?.['@id'] || `${API}${API_ROUTES.EXPENSE_TYPES}/${object?.uuid}`) : null;
        setExpenseType(expense);
        setValue('expenseType', expense);
    }

    const handleDateChange = (e) => {
        setDate(e);
        setValue('date', e);
    }

    const onSubmit = (data) => {
        if (uuid) {
            enqueueSnackbar(
                'Uspešno ste izmenili trošak', {
                variant: 'success'
            });
            return dispatch(putExpense(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno ste sačuvali trošak', {
            variant: 'success'
        });
        return dispatch(postExpense(data));
    }

    const handleClickBackToTabs = () => {
        history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TAB });
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Trošak</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToTabs}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <Autocomplete
                            name="expenseType"
                            control={control}
                            rules={{ required: 'Unesite tip troška' }}
                            api={API_ROUTES.EXPENSE_TYPES}
                            label="Tip troška"
                            handleObject={handleExpenseTypeObject}
                            preloadValue={expenseType}
                        />
                        <ErrorMessage errors={errors} name="expenseType" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            name="amount"
                            control={control}
                            rules={{ required: 'Unesite iznos' }}
                            label="Iznos"
                        />
                        <ErrorMessage errors={errors} name="amount" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <DatePicker
                            name="date"
                            control={control}
                            rules={{ required: 'Unesite datum', validate: date => isValid(new Date(date)) || 'Nepravilan datum' }}
                            label="Datum"
                            value={date}
                            onChange={handleDateChange}
                        />
                        <ErrorMessage errors={errors} name="date" as="p" />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Expense.propTypes = {
    expenses: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenses: state.expenses
});

export default connect(mapStateToProps)(Expense);
